/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon20Regular = forwardRef('ArrowCRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.845 3.22a.75.75 0 0 1 1.06 0l4.836 4.836a2.75 2.75 0 0 1 0 3.889L7.905 16.78a.75.75 0 1 1-1.06-1.061l4.836-4.836a1.25 1.25 0 0 0 0-1.768L6.845 4.28a.75.75 0 0 1 0-1.06Z" })));
});
